import {
  Button,
  CheckboxSelect,
  DefaultModalDialog,
  FixedScreenHeaderStack,
  Heading,
  Link,
  SearchAndAddBar,
} from '~/common/components/defaultUIComponents';
import DepartmentApi from '~/common/api/zeiterfassungServerApi/DepartmentApi';
import { useChecklistPdfDownloader, useMergeJobs, useProject } from './utils';
import { Flex, IconButton, Select, Tooltip } from '@chakra-ui/react';
import { useProjectContext } from './ProjectContext';
import routes from '~/common/constants/routes.json';
import useTranslate from '~/common/utils/translate';
import { CloudDownload } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import _ from 'lodash';

export const ProjectHeader: React.FC = () => {
  const navigate = useNavigate();
  const { setSearchTerm } = useProjectContext();
  const { project } = useProject();
  const { jobs } = useProject();
  const { mergeJobs, merging, setMerging } = useMergeJobs();
  const translate = useTranslate();
  const { selectValue, setSelectValue } = useProjectContext();
  const [{ data: departments }] = DepartmentApi.hooks.useDepartmentsQuery({
    select: (data) => {
      const departmentIds = new Set(jobs.map((job) => job.department?.id));
      return data.filter((department) => departmentIds.has(department.id));
    },
  });
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = parseInt(event.target.value);
    setSelectValue(newValue as React.SetStateAction<number>);
  };
  const { handleGetChecklist, isChecklistPdfLoading } =
    useChecklistPdfDownloader(project!);

  return (
    <>
      <DefaultModalDialog
        dialogHeaderText="projectTile.mergeJobs.dialogHeaderText"
        submitText="projectTile.mergeJobs.dialogHeaderText"
        isOpen={merging}
        onCancel={() => setMerging(false)}
        onSubmit={mergeJobs}
        showCancelButton
        size="xl"
        initialValues={{ jobIds: [] }}
      >
        <CheckboxSelect
          name="jobIds"
          fields={_.orderBy(project?.jobs, 'step_number')}
          labels={(job) => {
            return job.name;
          }}
          values={(job) => {
            return job.id;
          }}
          keys={(job) => {
            return job.id;
          }}
          boxProps={{
            maxH: '30vh',
            overflowY: 'scroll',
          }}
        />
      </DefaultModalDialog>
      {project && (
        <FixedScreenHeaderStack>
          <Flex justify="space-between" alignItems="center">
            <Link
              href={routes.EDIT_PROJECT.replace(':id', project?.id?.toString())}
            >
              <Heading>Projekt: {project?.name}</Heading>
            </Link>
            <Flex gap={2}>
              <Tooltip
                label={translate('project.jobs.button.showPDF.text') as string}
              >
                <IconButton
                  aria-label="pdf-export"
                  size="md"
                  icon={<CloudDownload />}
                  onClick={() => {
                    void handleGetChecklist();
                  }}
                  isLoading={isChecklistPdfLoading}
                />
              </Tooltip>
              <Button onClick={() => setMerging(true)}>
                projectTile.mergeJobs.dialogHeaderText
              </Button>
            </Flex>
          </Flex>
          <Heading fontSize="large">project.jobs</Heading>
          <Flex alignItems="center" justify="space-between">
            <Flex width="70%">
              <SearchAndAddBar
                onInputChange={setSearchTerm}
                onClick={() =>
                  navigate(
                    routes.CREATE_JOB.replace(
                      ':project',
                      project?.id?.toString(),
                    ),
                  )
                }
                inputPlaceholder={'project.jobs.search'}
                tooltipLabel={'project.jobs.create'}
              />
            </Flex>
            <Flex width="30%" ml="2rem">
              <Select value={selectValue} onChange={handleSelectChange}>
                <option value="-1">
                  {selectValue === -1
                    ? translate('project.jobs.filter.default')
                    : translate('project.jobs.filter.reset')}
                </option>
                {_.orderBy(departments, [(e) => e.name], ['asc'])?.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </Select>
            </Flex>
          </Flex>
        </FixedScreenHeaderStack>
      )}
    </>
  );
};
